import {
  Cell,
  Grid,
  HeadingSection,
  InfoLabel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Text,
  useStyles,
} from 'bold-ui'
import { TableBox } from 'components/table/TableBox'
import { RastreioCancerPerguntaDbEnum } from 'graphql/types.generated'
import { useMemo } from 'react'

import { MamografiaPerguntaField } from '../model-mamografia'
import { anamneseCirurgiaTableOptions, MAMOGRAFIA_PERGUNTAS_ANAMNESE } from './model-anamnese'

export interface MamografiaAnamneseVisualizacaoSectionProps {
  questoesRespondidas: Map<RastreioCancerPerguntaDbEnum, string>
}

export function MamografiaAnamneseVisualizacaoSection(props: Readonly<MamografiaAnamneseVisualizacaoSectionProps>) {
  const { questoesRespondidas } = props
  const { classes } = useStyles(createStyles)

  const anamneseRespondida = useMemo(
    () =>
      (Object.keys(MAMOGRAFIA_PERGUNTAS_ANAMNESE) as RastreioCancerPerguntaDbEnum[])
        .filter((questao) => questoesRespondidas.has(questao))
        .map((questao) => [questao, questoesRespondidas.get(questao)!] as const),
    [questoesRespondidas]
  )

  const cirurgiasRealizadas = useMemo(
    () =>
      anamneseCirurgiaTableOptions.filter(
        ({ valueDireita, valueEsquerda }) =>
          questoesRespondidas.has(valueDireita) || questoesRespondidas.has(valueEsquerda)
      ),
    [questoesRespondidas]
  )

  return (
    <>
      {anamneseRespondida.length > 0 && (
        <>
          <HeadingSection level={4} vSpace={2} title='ANAMNESE' />
          <Grid style={classes.grid}>
            {anamneseRespondida.map(([questao, resposta]) => (
              <Cell key={questao} size={6}>
                <InfoLabel title={MAMOGRAFIA_PERGUNTAS_ANAMNESE[questao]!}>{resposta}</InfoLabel>
              </Cell>
            ))}
          </Grid>
        </>
      )}
      {questoesRespondidas.get(MamografiaPerguntaField.fezCirurgiaMama) == 'Sim' && (
        <TableBox>
          <Table style={classes.table}>
            <TableHead>
              <TableRow>
                <TableHeader style={classes.header}>Opções de cirurgia</TableHeader>
                <TableHeader style={classes.header}>Mama direita</TableHeader>
                <TableHeader style={classes.header}>Mama esquerda</TableHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {cirurgiasRealizadas.map(({ label, valueDireita, valueEsquerda }) => (
                <TableRow key={label}>
                  <TableCell style={classes.cell}>
                    <Text>{label}</Text>
                  </TableCell>
                  <TableCell style={classes.cell}>
                    <Text>{questoesRespondidas.get(valueDireita) ?? '-'}</Text>
                  </TableCell>
                  <TableCell style={classes.cell}>
                    <Text>{questoesRespondidas.get(valueEsquerda) ?? '-'}</Text>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableBox>
      )}
    </>
  )
}

const createStyles = () => ({
  grid: {
    width: '100%',
  },
  table: {
    padding: '1rem',
  },
  header: {
    width: '33.33%',
  },
  cell: {
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
  },
})
